<div class="notification-popup-v2">
  <div class="notification-title">
    <span>
      <span
        class="icon-container"
        *ngIf="options.payload.icon"
        [ngClass]="{
          'warning-icon': options.payload.icon?.background === IconBackground.WARNING,
          'info-icon': options.payload.icon?.background === IconBackground.INFO,
          'error-icon': options.payload.icon?.background === IconBackground.ERROR,
          'success-icon': options?.payload.icon?.background === IconBackground.SUCCESS,
          'user-icon-container': options?.payload.icon?.user
        }"
      >
        <ng-container [ngSwitch]="options.payload.icon?.type">
          <svg-icon
            *ngSwitchCase="'svg-icon'"
            [icon]="options.payload.icon?.assetName"
            [width]="options.payload.icon?.width"
            [height]="options.payload.icon?.height"
          >
          </svg-icon>
          <app-pencil-icon
            *ngSwitchCase="'lucide-icon'"
            [name]="options.payload.icon?.assetName"
            [type]="IconTypes.lucideIcon"
            [wrapperStyle]="{
              width: (options.payload.icon?.width || 18) + 'px',
              height: (options.payload.icon?.height || 18) + 'px'
            }"
          ></app-pencil-icon>
          <mat-icon
            *ngSwitchCase="'mat-icon'"
            [ngClass]="{ 'material-icons-outlined': options.payload.icon?.outlined }"
            [ngStyle]="{
              'font-size': options.payload.icon?.size + 'px',
              width: options.payload.icon?.size + 'px',
              height: options.payload.icon?.size + 'px',
              'line-height': options.payload.icon?.size + 'px'
            }"
          >
            {{ options.payload.icon?.assetName }}
          </mat-icon>

          <app-pencil-spinner
            *ngSwitchCase="'spinner'"
            [diameter]="18"
            class="spinner"
            [ngStyle]="options.payload.icon?.spinnerStyle"
            [strokeWidth]="2.25"
          ></app-pencil-spinner>

          <app-profile-photo
            *ngSwitchCase="'user'"
            [user]="options.payload.icon?.user"
            [width]="options.payload.icon?.size"
            [isClickEnabled]="false"
          ></app-profile-photo>
        </ng-container>
      </span>
    </span>
    <!--    Main Title text-->
    <span class="title" *ngIf="options.payload?.title">{{ options.payload.title }}</span>

    <span class="x-close" (click)="onClose()" *ngIf="options.payload?.dismissible">
      <svg-icon icon="close-notification-icon"></svg-icon>
    </span>
  </div>

  <!--  Notification Description -->
  <div class="notification-description" *ngIf="options.payload.description">
    <span [innerHtml]="options.payload.description"></span>
  </div>

  <!--  Tertiary or Link Button -->
  <div class="notification-tertiary-action" *ngIf="options.payload.actionButtonsConfig?.link">
    <app-pencil-button
      class="pencil-button link-btn notification-button-link"
      [label]="options.payload.actionButtonsConfig?.link?.text"
      (clickEvent)="handleActionButtonClick(options.payload.actionButtonsConfig?.link)"
    >
    </app-pencil-button>
  </div>

  <!-- Progress bar in action area -->
  <div class="notification-actions" *ngIf="options.payload.actionProgressBarObservable">
    <div class="action-progress-bar">
      <div
        class="progress-bar-fill"
        [style.width.%]="options.payload.actionProgressBarObservable | async"
      ></div>
    </div>
  </div>

  <!-- Action buttons -->
  <div class="notification-actions" *ngIf="options.payload.actionButtonsConfig">
    <!--    Secondary action buttons-->
    <div class="action-button" *ngIf="options.payload.actionButtonsConfig?.secondary">
      <app-pencil-button
        class="pencil-button action-secondary light"
        [ngClass]="{ 'with-options': options.payload.actionButtonsConfig?.secondary?.options }"
        [label]="options.payload.actionButtonsConfig?.secondary?.text"
        [icon]="options.payload.actionButtonsConfig?.secondary?.icon"
        [iconConfig]="options.payload.actionButtonsConfig?.secondary?.iconConfig"
        (clickEvent)="handleActionButtonClick(options.payload.actionButtonsConfig.secondary)"
      ></app-pencil-button>

      <!--      Options Menu Trigger-->
      <app-pencil-button
        *ngIf="options.payload.actionButtonsConfig?.secondary?.options"
        class="pencil-button light options-action-btn"
        [iconConfig]="{
          type: 'material-icon',
          outlined: true
        }"
        icon="keyboard_arrow_down"
        [matMenuTriggerFor]="secondaryOptionsMenu"
      >
      </app-pencil-button>

      <!--      Options Menu for Secondary operations-->
      <mat-menu
        [hidden]="!options.payload.actionButtonsConfig?.secondary?.options?.items"
        #secondaryOptionsMenu="matMenu"
        class="notifications-more-menu"
        (click)="$event.stopPropagation()"
      >
        <ng-template matMenuContent>
          <button
            class="notifications-more-menu-button"
            *ngFor="let option of options.payload.actionButtonsConfig?.secondary?.options?.items"
            (click)="option.onClick()"
          >
            <span> {{ option.text }} </span>
          </button>
        </ng-template>
      </mat-menu>
    </div>
    <!--    Primary action button -->
    <div class="action-button" *ngIf="options.payload.actionButtonsConfig?.primary">
      <app-pencil-button
        class="pencil-button action-primary primary"
        [ngClass]="{ 'with-options': options.payload.actionButtonsConfig?.primary?.options }"
        [label]="options.payload.actionButtonsConfig?.primary?.text"
        [icon]="options.payload.actionButtonsConfig?.primary?.icon"
        [iconConfig]="options.payload.actionButtonsConfig?.primary?.iconConfig"
        (clickEvent)="handleActionButtonClick(options.payload.actionButtonsConfig.primary)"
      >
      </app-pencil-button>

      <!--      options or actions trigger-->
      <app-pencil-button
        *ngIf="options.payload.actionButtonsConfig?.primary?.options"
        class="pencil-button primary options-action-btn"
        [iconConfig]="{
          type: 'material-icon',
          outlined: true
        }"
        icon="keyboard_arrow_down"
        [matMenuTriggerFor]="primaryOptionsMenu"
      >
      </app-pencil-button>

      <!--      Primary menu actions-->
      <mat-menu
        #primaryOptionsMenu="matMenu"
        [hidden]="!options.payload.actionButtonsConfig?.primary?.options?.items"
        class="notifications-more-menu"
        (click)="$event.stopPropagation()"
      >
        <ng-template matMenuContent>
          <button
            class="notifications-more-menu-button"
            *ngFor="let option of options.payload.actionButtonsConfig?.primary?.options?.items"
            (click)="option.onClick()"
          >
            <span> {{ option.text }} </span>
          </button>
        </ng-template>
      </mat-menu>
    </div>
  </div>

  <!-- Bottom timeout progress bar -->
  <div *ngIf="options.payload.showProgressBar" class="progress-bar-container">
    <div class="timer-animation" [style.animation-duration]="options.payload.timeout + 'ms'"></div>
  </div>
</div>
